module.exports = __webpack_public_path__ + "static/media/add.2139e0e2.png";